import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./pages/Header";
import Home from "./pages/Home";
import Blogs from "./pages/Blogs";
import NoPage from "./pages/NoPage";
import Moobeen from "./pages/Moobeen";
import Footer from "./pages/Footer";
import Filter from "./pages/Filter";
import FilterwithImage from "./pages/FilterwithImage";
import { Helmet } from "react-helmet";
/// import mImage from './public/logo512.png'
import Spelling from "./pages/spelling";
import TypingEffect from "./pages/TypingEffect";
import Autocom from "./pages/Autocom";
import Autocomtyp from "./pages/Autocomtyp";
import PostList from "./posts/PostList";
import PostDetail from "./posts/PostDetail";
import PostDetail2 from "./posts/PostDetail2";
import PostSearch from "./posts/PostSearch";
import CF from "./pages/cf";
import { Toaster } from "react-hot-toast";

export default function App() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>React Home Page</title>
        <link rel="canonical" href="http://mysite.com/example" />
      </Helmet>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#1f2937",
            color: "#fff",
            borderRadius: "10px",
          },
          success: {
            iconTheme: {
              primary: "#22c55e",
              secondary: "#fff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
      {/* <img src={mImage} alt="ss" /> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Header />}>
            <Route index element={<Home />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/moobeen" element={<Moobeen />} />
            <Route path="/filter" element={<Filter />} />
            <Route path="/spelling" element={<Spelling />} />
            <Route path="/typingeffect" element={<TypingEffect />} />
            <Route path="/autocom" element={<Autocom />} />
            <Route path="/autocomtyp" element={<Autocomtyp />} />
            <Route path="/filterwithimage" element={<FilterwithImage />} />
            <Route path="/postsearch" element={<PostSearch />} />
            <Route path="/postlist" element={<PostList />} />
            <Route path="/postsbyid/:postId" element={<PostDetail />} />
            <Route path="/posts/:slug" element={<PostDetail2 />} />
            <Route path="/contact" element={<CF />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
